import { Typography } from "@mui/material";
import type { LogRecord } from "../../../api/client";
import type { Column } from "../CompGrid";
import { LogIdLink } from "../../links/IdLink";
import { formatLogMessage } from "@/client/utils/formatting";

export function createCommonLogColumns(options: {
  serviceSlug: string | null | undefined;
}): Column<LogRecord>[] {
  const { serviceSlug } = options;

  return [
    {
      id: "timestamp",
      label: "Time",
      sortable: true,
      sortValue: (log) => new Date(log.ts).getTime(),
      render: (log) => <Typography variant="body2">{new Date(log.ts).toLocaleString()}</Typography>,
    },
    {
      id: "log_id",
      label: "Log ID",
      sortable: true,
      sortValue: (log) => log.log_id,
      render: (log) => <LogIdLink serviceSlug={serviceSlug} logId={log.log_id} />,
    },
    {
      id: "body",
      label: "Message",
      sortable: true,
      sortValue: (log) => log.body,
      render: (log) => <Typography variant="body2">{formatLogMessage(log.body, log.log_attrs)}</Typography>,
    },
    {
      id: "severity",
      label: "Severity",
      sortable: true,
      sortValue: (log) => log.severity_text || "",
      render: (log) => <Typography variant="body2">{log.severity_text}</Typography>,
    },
    {
      id: "service",
      label: "Service",
      sortable: true,
      sortValue: (log) => log.service_name,
      render: (log) => (
        <Typography variant="body2">
          {log.service_name}
          {log.service_instance && ` (${log.service_instance})`}
        </Typography>
      ),
    },
  ];
}
